import type { ReactNode } from 'react';
import type { UserRole } from 'used-vehicle-contracts';
import { useI18nTranslation } from '../lib/use-i18n-translation';
import { useAuth } from './AuthContext';

export interface RequireRoleProps {
  roles: readonly UserRole[];
  children: ReactNode;
}

/** Renders `children` only for the listed roles; anyone else gets a plain "not allowed" panel. */
export const RequireRole = ({ roles, children }: RequireRoleProps) => {
  const { user } = useAuth();
  const { t } = useI18nTranslation();

  if (!user || !roles.includes(user.role)) {
    return (
      <div className="rounded-lg border border-border bg-card p-8">
        <h1 className="text-lg font-semibold text-card-foreground">{t('errors.forbiddenTitle')}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{t('errors.forbiddenBody')}</p>
      </div>
    );
  }

  return <>{children}</>;
};
